module.exports = __webpack_public_path__ + "static/media/risk--mobile--en.fd48520a.png";